import { connect } from 'react-redux';

import { Newobjects } from './index';
import { IAppState } from '../../../common/state';

export const NewobjectsContainer = connect((state: IAppState) => ({
  similarNewobjects: state.similarNewobjects,
  aggregatedOffers: state.results.aggregatedOffers,
}))(Newobjects);
